/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { Skeleton } from "./Skeleton";
export { SkeletonShape } from "./SkeletonProps";
export type { SkeletonProps } from "./SkeletonProps";
